import { render, staticRenderFns } from "./OnlineReading.vue?vue&type=template&id=3c83864b&scoped=true"
import script from "./OnlineReading.vue?vue&type=script&lang=js"
export * from "./OnlineReading.vue?vue&type=script&lang=js"
import style0 from "./OnlineReading.vue?vue&type=style&index=0&id=3c83864b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83864b",
  null
  
)

export default component.exports